import { render, staticRenderFns } from "./seting.vue?vue&type=template&id=797f6b11&scoped=true"
import script from "./seting.vue?vue&type=script&lang=js"
export * from "./seting.vue?vue&type=script&lang=js"
import style0 from "./seting.vue?vue&type=style&index=0&id=797f6b11&prod&lang=scss&scoped=true"
import style1 from "./seting.vue?vue&type=style&index=1&id=797f6b11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f6b11",
  null
  
)

export default component.exports